import React from 'react'
import { CardBody, Col, Row } from 'react-bootstrap';
import ButtonComponent from '../../../../components/ButtonComponent';
import EditButtonComponent from '../../../../components/EditButtonComponent';
import { useUpdateCartPersonBankDataMutation } from '../../../../redux/services/cartSearchService';
import { Input, Label } from 'reactstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSpinner } from '@fortawesome/free-solid-svg-icons';
import { toast } from 'react-toastify';
import { useNavigate } from 'react-router-dom';
import { CartPersonDetailsProps } from '../CartPersonDetails';

const BankDetails: React.FC<CartPersonDetailsProps> = ({ cartPerson }) => {
    const navigate = useNavigate();

    const [editMode, setEditMode] = React.useState(true);
    const [isSaving, setIsSaving] = React.useState(false);

    const handleEdit = () => {
        setEditMode(!editMode);
    }

    const [bankDetails, setBankDetails] = React.useState({
        cartPersonId: cartPerson?.id || "",
        accountName: cartPerson?.bankAccountDetails?.accountName || "",
        accountNumber: cartPerson?.bankAccountDetails?.accountNumber || "",
        bankName: cartPerson?.bankAccountDetails?.bankName || "",
        branchName: cartPerson?.bankAccountDetails?.branchName || "",
        swiftCode: cartPerson?.bankAccountDetails?.swiftCode || "",
    });

    const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const { name, value } = e.target;
        setBankDetails((prevDetails) => ({
            ...prevDetails,
            [name]: value,
        }));
    };

    const [updateBankDetails] = useUpdateCartPersonBankDataMutation();

    const handleSaveBankDetails = async () => {
        try {
            setIsSaving(true);
            await updateBankDetails(bankDetails).unwrap();
            toast.success("Bank details updated successfully");
            navigate("/cartpersons/cartperson-list");
            setIsSaving(false);
        }
        catch (err) {
            toast.error("Failed to update bank details");
            setIsSaving(false);
        }
    }

    return (
        <>
            <CardBody>
                <div className="d-flex justify-content-end mb-3">
                    <EditButtonComponent onClick={handleEdit} />
                </div>
                <Row className='m-2 mt-0'>
                    <Col lg="2">
                        <Label>Account Name</Label>
                    </Col>
                    <Col lg="4">
                        <Input name="accountName" value={bankDetails.accountName} onChange={handleInputChange} disabled={editMode} /></Col>
                    <Col lg="2">
                        <Label>Account Number</Label>
                    </Col>
                    <Col lg="4">
                        <Input name="accountNumber" value={bankDetails.accountNumber} onChange={handleInputChange} disabled={editMode} /></Col>
                </Row>
                <Row className='m-2 mt-0'>
                    <Col lg="2">
                        <Label>Bank Name</Label>
                    </Col>
                    <Col lg="4">
                        <Input name="bankName" value={bankDetails.bankName} onChange={handleInputChange} disabled={editMode} /></Col>
                    <Col lg="2">
                        <Label>Branch Name</Label>
                    </Col>
                    <Col lg="4">
                        <Input name="branchName" value={bankDetails.branchName} onChange={handleInputChange} disabled={editMode} /></Col>
                </Row>
                <Row className='m-2 mt-0'>
                    <Col lg="2">
                        <Label>Swift Code</Label>
                    </Col>
                    <Col lg="4">
                        <Input name="swiftCode" value={bankDetails.swiftCode} onChange={handleInputChange} disabled={editMode} /></Col>
                        <Col lg="6" className="mt-lg-0 mt-2">
                        {isSaving ? <ButtonComponent icon={<FontAwesomeIcon icon={faSpinner} spin
                        />} titel='Saving...' fullWidth isDisabled={true} /> : <ButtonComponent titel='Save' onClick={handleSaveBankDetails} fullWidth isDisabled={editMode} />}
                    </Col>
                </Row>
            </CardBody></>
    )
}

export default BankDetails;